import { render } from "./Discount.vue?vue&type=template&id=01cd219e&scoped=true&ts=true"
import script from "./Discount.vue?vue&type=script&lang=ts"
export * from "./Discount.vue?vue&type=script&lang=ts"

import "./Discount.vue?vue&type=style&index=0&id=01cd219e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cd219e"]])

export default __exports__